import Vue from 'vue';
import VueRx from 'vue-rx';

Vue.use(VueRx);

import { Routes, RouteNames } from './routes';

import { SDK } from './common/sdk';
import { Cache } from './common/cache';
import { Auth } from './common/auth';

import './styles/styles.scss';

// import { Auth } from './auth';

Vue.config.productionTip = false;

// @ts-ignore
import VueMoment from 'vue-moment';
Vue.use(VueMoment);

import VueRouter from 'vue-router';
Vue.use(VueRouter);

// @ts-ignore
import Vuikit from 'vuikit';
Vue.use(Vuikit);

import '@vuikit/theme';

// Custom components
import ModalComponent from '@/components/modal.vue';
import LoaderComponent from '@/components/lantern-loader.vue';
import EnrollComponent from '@/components/lantern-enroll.vue';
import SectionComponent from '@/components/lantern-section.vue';

Vue.component('modal', ModalComponent);
Vue.component('lantern-loader', LoaderComponent);
Vue.component('lantern-enroll', EnrollComponent);
Vue.component('lantern-section', SectionComponent);

export const router = new VueRouter({
    mode: 'history',
    routes: Routes
});

if (!process.env.VUE_APP_SERVICE_HOST) throw new Error('Missing process.env.VUE_APP_SERVICE_HOST!');

// Lantern sdk must be installed before the Auth plugin
Vue.use(SDK.LanternSDKPlugin, {
    host: process.env.VUE_APP_SERVICE_HOST
});

Vue.use(Cache.CachePlugin);

Vue.use(Auth.CanvasOAuthPlugin, {
    onRedirectCallback: (appState: any) => {
        router.replace('/');
    }
});

router.onError(error => {
    return router.replace({ name: RouteNames.error, params: { error: error as any } });
});

import AppComponent from '@/views/app.vue';
new Vue({
    router,
    render: h => h(AppComponent)
}).$mount('#app');
